import React from 'react'
import mirador from 'mirador'
import MiradorMenuButton from 'mirador/dist/es/src/containers/MiradorMenuButton'
import CloseIcon from '@material-ui/icons/SpeakerNotesOffSharp'

interface IProps {
  deselectAnnotations?: () => void
  selectedAnnotations: string
}

const DeselectAnnotationButton: React.FC<IProps> = ({
  deselectAnnotations,
  selectedAnnotations,
}) => {
  if (selectedAnnotations) {
    return (
      <MiradorMenuButton
        aria-label="Close all annotation windows"
        onClick={deselectAnnotations}
      >
        <CloseIcon />
      </MiradorMenuButton>
    )
  }

  return <div />
}

const mapDispatchToProps = (
  dispatch: (arg0: unknown) => void,
  { annotationId, windowId }: { annotationId: string; windowId: string },
): { deselectAnnotations: () => void } => ({
  deselectAnnotations: () => {
    dispatch({
      annotationId,
      windowId,
      type: 'mirador/DESELECT_ANNOTATION',
    })
  },
})

const mapStateToProps = (
  state: never,
  { windowId }: { windowId: string },
): { selectedAnnotations: string } => ({
  selectedAnnotations: mirador.selectors.getSelectedAnnotationId(state, {
    windowId,
  }),
})

const exportedObject = {
  name: 'DeselectAnnotationButton',
  target: 'WindowTopBarPluginArea',
  mode: 'add',
  component: DeselectAnnotationButton,
  mapDispatchToProps,
  mapStateToProps,
}
export default exportedObject
